module.exports = __webpack_public_path__ + "img/white_logoUfma.38243ace.svg";